<template>
  <div class="selectcity">
    <div @click="show()">
      <slot></slot>
    </div>
    <div
      class="city-pc-mask"
      v-if="device === 'PC' && showPopup"
      @click="showPopup = false"
    ></div>
    <transition @before-enter="beforeEnter" @enter="enter" @leave="leave">
      <div class="city-pc" v-if="device === 'PC' && showPopup">
        <div class="city-popup-content">
          <div class="city-popup-title">
            <div class="city-title">体验网点</div>
            <div @click.prevent="e_closePick()">
              <svg-icon name="MenuExpand"></svg-icon>
            </div>
          </div>
          <div class="city-popup-select" ref="popupSelect">
            <span
              class="city-show"
              @click="e_selectProvince"
              :class="{ 'city-active': !provinceItem.nodeName || showProvince }"
              >{{ provinceItem.nodeName ? provinceItem.nodeName : "请选择" }}
            </span>
            <span
              class="city-show"
              v-if="provinceItem.nodeCode"
              @click="e_selectCity"
              :class="{ 'city-active': !cityItem.nodeName || showCity }"
              >{{ cityItem.nodeName ? cityItem.nodeName : "请选择" }}
            </span>
            <span
              class="city-show"
              v-if="cityItem.nodeCode"
              @click="e_selectShop"
              :class="{
                'city-active': !shopItem.offlineExperienceShopName || showShop,
              }"
              >{{
                shopItem.offlineExperienceShopName
                  ? shopItem.offlineExperienceShopName
                  : "请选择"
              }}
            </span>
          </div>
          <div ref="popupPick" class="city-popup-pick">
            <div
              class="province-pick-item pick-item"
              v-show="showProvince"
              v-for="item in dataList"
              :key="item.id"
              :class="{
                'pick-active': item.nodeName === provinceItem.nodeName,
              }"
              @click="e_pickProvince(item)"
            >
              <span> {{ item.nodeName }}</span>
              <svg-icon
                name="Checkmark"
                v-if="item.nodeName === provinceItem.nodeName"
              ></svg-icon>
            </div>
            <p
              class="city-pick-item pick-item"
              v-show="showCity"
              v-for="item in cityList"
              :key="item.id"
              :class="{ 'pick-active': item.nodeName === cityItem.nodeName }"
              @click="e_pickCity(item)"
            >
              <span> {{ item.nodeName }}</span>
              <svg-icon
                name="Checkmark"
                v-if="item.nodeName === cityItem.nodeName"
              ></svg-icon>
            </p>
            <div
              class="shop-pick-item pick-item"
              v-show="showShop"
              v-for="item in shopList"
              :key="item.id"
              :class="{
                'pick-active':
                  item.offlineExperienceShopId ===
                  shopItem.offlineExperienceShopId,
              }"
              @click="e_pickShop(item)"
            >
              <div>
                <div class="shop-name">
                  {{ item.offlineExperienceShopName }}
                </div>
                <div class="shop-address">
                  {{ item.address }}
                </div>
                <div v-if="item.distanceStr" class="distance">
                  {{ item.distanceStr || "1km" }}
                </div>
              </div>
              <svg-icon
                name="Checkmark"
                v-if="
                  item.offlineExperienceShopId ===
                    shopItem.offlineExperienceShopId
                "
              ></svg-icon>
            </div>
          </div>
        </div>
      </div>
    </transition>
    <Drawer
      v-if="device !== 'PC'"
      type="bottom"
      :zIndex="9999"
      height="calc(100vh - 80px)"
      maskbgColor="rgba(0, 0, 0, 0.40)"
      :visible.sync="showPopup"
    >
      <div class="city-popup-content">
        <div class="city-popup-title">
          <div class="city-title">体验网点</div>
          <div @click.prevent="e_closePick()">
            <svg-icon name="MenuExpand"></svg-icon>
          </div>
        </div>
        <div class="city-popup-select" ref="popupSelect">
          <span
            class="city-show"
            @click="e_selectProvince"
            :class="{ 'city-active': !provinceItem.nodeName || showProvince }"
            >{{ provinceItem.nodeName ? provinceItem.nodeName : "请选择" }}
          </span>
          <span
            class="city-show"
            v-if="provinceItem.nodeCode"
            @click="e_selectCity"
            :class="{ 'city-active': !cityItem.nodeName || showCity }"
            >{{ cityItem.nodeName ? cityItem.nodeName : "请选择" }}
          </span>
          <span
            class="city-show"
            v-if="cityItem.nodeCode"
            @click="e_selectShop"
            :class="{
              'city-active': !shopItem.offlineExperienceShopName || showShop,
            }"
            >{{
              shopItem.offlineExperienceShopName
                ? shopItem.offlineExperienceShopName
                : "请选择"
            }}
          </span>
        </div>
        <div ref="popupPick" class="city-popup-pick">
          <div
            class="province-pick-item pick-item"
            v-show="showProvince"
            v-for="item in dataList"
            :key="item.id"
            :class="{ 'pick-active': item.nodeName === provinceItem.nodeName }"
            @click="e_pickProvince(item)"
          >
            <span> {{ item.nodeName }}</span>
            <svg-icon
              name="Checkmark"
              v-if="item.nodeName === provinceItem.nodeName"
            ></svg-icon>
          </div>
          <p
            class="city-pick-item pick-item"
            v-show="showCity"
            v-for="item in cityList"
            :key="item.id"
            :class="{ 'pick-active': item.nodeName === cityItem.nodeName }"
            @click="e_pickCity(item)"
          >
            <span> {{ item.nodeName }}</span>
            <svg-icon
              name="Checkmark"
              v-if="item.nodeName === cityItem.nodeName"
            ></svg-icon>
          </p>
          <div
            class="shop-pick-item pick-item"
            v-show="showShop"
            v-for="item in shopList"
            :key="item.id"
            :class="{
              'pick-active':
                item.offlineExperienceShopId ===
                shopItem.offlineExperienceShopId,
            }"
            @click="e_pickShop(item)"
          >
            <div>
              <div class="shop-name">
                {{ item.offlineExperienceShopName }}
              </div>
              <div class="shop-address">
                {{ item.address }}
              </div>
              <div v-if="item.distanceStr" class="distance">
                {{ item.distanceStr || "1km" }}
              </div>
            </div>
            <svg-icon
              name="Checkmark"
              v-if="
                item.offlineExperienceShopId ===
                  shopItem.offlineExperienceShopId
              "
            ></svg-icon>
          </div>
        </div>
      </div>
    </Drawer>
  </div>
</template>
<script>
import { get4City, getShopListSimple, getDmsShopByCoord } from "@api/testDrive";
import SvgIcon from "@components/Icon/index.vue";
import Drawer from "@/components/Drawer/index.vue";
import { getDevice } from "@utils/device";
import AMapLoader from "@amap/amap-jsapi-loader";
import { getMapKey } from "@utils/map";
import useTransitionMixin from "@/utils/composables/useTransitionMixin";
export default {
  name: "outletSelect",
  mixins: [useTransitionMixin()],
  components: {
    SvgIcon,
    Drawer,
  },
  props: {
    carType: String,
  },
  data() {
    return {
      dataList: [],
      valueData: "",
      provinceItem: {},
      cityItem: {},
      shopItem: {},
      cityList: [],
      shopList: [],
      showPopup: false,
      showProvince: true,
      showCity: false,
      showShop: false,
      device: "",
      position: {},
      positionShop: {},
    };
  },
  watch: {
    positionShop: {
      handler: function(val, oldVal) {
        if (Object.keys(val).length) {
          const {
            id,
            name,
            cityName,
            cityNumber,
            provinceName,
            provinceNumber,
          } = val;
          const item = this.dataList.find((i) => i.nodeCode == provinceNumber);
          const provinceItem = {
            nodeName: provinceName,
            nodeCode: provinceNumber,
          };

          if (item) {
            provinceItem.children = item.children;
          }
          const cityItem = {
            nodeName: cityName,
            nodeCode: cityNumber,
          };
          const shopItem = {
            offlineExperienceShopName: name,
            offlineExperienceShopId: id,
          };

          provinceItem.nodeCode && this.e_pickProvince(provinceItem);
          cityItem.nodeCode && this.e_pickCity(cityItem);
          id && this.e_pickShop(shopItem);
        }
      },
      immediate: true,
    },
    carType(val) {
      console.log(val);
      this.changeCarType();
      this.getDealerList();
      this._initAMap();
    },
  },
  created() {
    get4City().then((res) => {
      this.dataList = res.data;
    });
  },
  mounted() {
    this.handleResize();
    window.addEventListener("resize", this.handleResize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.handleResize);
  },
  methods: {
    _initAMap() {
      // 第一步设置密钥
      window._AMapSecurityConfig = {
        securityJsCode: getMapKey().secretkey,
      };

      // 第二步加载JSSDK
      AMapLoader.load({
        key: getMapKey().appkey, //设置您的key
        version: "2.0",
        plugins: ["AMap.Geolocation"],
        AMapUI: {
          version: "1.1",
          plugins: [],
        },
        Loca: {
          version: "2.0",
        },
      })
        .then((AMap) => {
          const geolocation = new AMap.Geolocation({
            enablehighaccuracy: true, // 是否使用高精度定位，默认:true
            timeout: 10000, // 超过10秒后停止定位，默认：无穷大
            maximumage: 0, // 定位结果缓存0毫秒，默认：0
            convert: true, // 自动偏移坐标，偏移后的坐标为高德坐标，默认：true
          });
          geolocation.getCurrentPosition();
          AMap.Event.addListener(geolocation, "complete", (result) => {
            // 定位成功，result 包含经度和纬度信息
            const latitude = result.position.lat;
            const longitude = result.position.lng;
            this.position = {
              lat: latitude,
              lng: longitude,
            };
            this.getNearbyShop(result.position);
            console.log("Latitude: " + latitude);
            console.log("Longitude: " + longitude);
          });
          AMap.Event.addListener(geolocation, "error", (err) => {
            console.log("高德定位错误信息====>", err);
          });
        })
        .catch((e) => {
          console.log("初始化错误信息：", e);
        });
    },
    // 附近门店
    getNearbyShop(res) {
      getDmsShopByCoord({
        longitude: res.lng,
        latitude: res.lat,
        carSeriesCode: this.carType,
        carSeriesCodeForAppointed: this.carType,
      }).then((res) => {
        this.positionShop = res.data || {};
      });
    },

    handleResize() {
      this.device = getDevice();
      this.showPopup = false;
    },
    show() {
      this.showPopup = true;
      this.$nextTick(() => {
        if (this.$refs.popupSelect) {
          this.$refs.popupSelect.scrollLeft = 500;
        }
      });
      if (
        !this.shopItem.offlineExperienceShopId &&
        this.shopItem.offlineExperienceShopId !== 0
      ) {
        this._initAMap();
      }
    },
    changeCarType() {
      this.shopItem = {};
    },
    clearValue() {
      this.valueData = "";
      this.provinceItem = {};
      this.cityItem = {};
      this.shopItem = {};
      this.cityList = [];
      this.shopList = [];
      this.showPopup = false;
      this.showProvince = true;
      this.showCity = false;
      this.showShop = false;
    },
    e_openPick() {
      if (this.dataList && this.dataList.length) {
        this.showPopup = true;
      }
    },
    e_closePick() {
      this.showPopup = false;
    },
    e_selectProvince() {
      this.showProvince = true;
      this.showShop = false;
      this.showCity = false;
      this.popupPickScrollTop();
      if (this.$refs.popupSelect) {
        this.$refs.popupSelect.scrollLeft = 0;
      }
    },
    e_selectCity() {
      this.showProvince = false;
      this.showShop = false;
      this.showCity = true;
      this.popupPickScrollTop();
      if (this.$refs.popupSelect) {
        this.$refs.popupSelect.scrollLeft = 500;
      }
    },
    e_selectShop() {
      this.showProvince = false;
      this.showCity = false;
      this.showShop = true;
      this.popupPickScrollTop();
      if (this.$refs.popupSelect) {
        this.$refs.popupSelect.scrollLeft = 500;
      }
    },

    e_pickProvince(item) {
      this.provinceItem = item;
      this.cityItem = {};
      this.shopItem = {};
      this.valueData = "";
      this.showProvince = false;
      this.showCity = true;
      if (item.nodeCode === "711314150") {
        this.showShop = true;
        this.showCity = false;
        this.getDealerList();
      }
      this.cityList = item.children;
      this.popupPickScrollTop();
    },
    e_pickCity(item) {
      if (item.nodeCode === this.cityItem.nodeCode) {
        return;
      }
      this.cityItem = item;
      this.valueData = "";
      this.shopList = [];
      this.shopItem = {};
      this.showProvince = false;
      this.showCity = false;
      this.showShop = true;
      this.popupPickScrollTop();
      this.getDealerList();
    },
    getDealerList() {
      const params = {
        longitude: this.position.lng || "",
        latitude: this.position.lat || "",
        authorizeCityAdCode: this.cityItem.nodeCode,
        carSeriesCodeForAppointed: this.carType,
      };
      getShopListSimple(params).then((res) => {
        if (res.code == 0) {
          this.shopList = res.data.records || [];
          if (this.$refs.popupSelect) {
            this.$refs.popupSelect.scrollLeft = 500;
          }
        }
      });
    },
    e_pickShop(item) {
      console.log("-------------");
      console.log(item);
      this.shopItem = item;
      this.valueData = item.offlineExperienceShopName;
      this.showPopup = false;
      console.log([this.provinceItem, this.cityItem, this.shopItem]);
      this.$emit("getData", [this.provinceItem, this.cityItem, this.shopItem]);
    },
    popupPickScrollTop() {
      if (this.$refs.popupPick) {
        this.$refs.popupPick.scrollTop = 0;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@style/base";
@import "@style/common";
@include setThemeClass {
  .selectcity {
    position: relative;
    .city-pc {
      height: 320px;
      transform-origin: top center;
      transition: transform 0.25s ease, opacity 0.25s ease;
      background-color: #fff;
      position: absolute;
      left: 0;
      right: 0;
      top: 60px;
      z-index: 10000;
    }
    .city-pc-mask {
      position: fixed;
      left: 0;
      right: 0;
      bottom: 0;
      top: 0;
    }
  }
  p {
    margin: 0;
  }
  .city-picker-container {
    font-size: 14px;
    line-height: 22px;
    position: relative;
    width: 100%;
  }

  .city-picker-box {
    display: flex;
    align-items: center;
    justify-content: space-between;
  }
  .city-picker-container .city-picker-input {
    text-align: left;
    line-height: 36px;
    max-width: 450px;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .city-picker-container .city-picker-input.null {
    color: #ccc;
  }

  .city-popup-title {
    display: none;
    justify-content: space-between;
    align-items: center;
    font-size: 18px;
    line-height: 28px;
    padding: 8px 16px;
    color: #131415;
    @include media(
      (
        $md: (
          display: flex,
        ),
      )
    );
  }

  .city-popup-select {
    font-size: 12px;
    padding: 9px 16px;
    font-size: 14px;
    line-height: 22px;
    display: flex;
    overflow: scroll;
    height: 40px;
    min-height: 40px;
    &::-webkit-scrollbar {
      display: none;
    }
    > * {
      white-space: nowrap;
    }
  }
  .city-popup-select .city-show {
    margin-right: 24px;
    color: #878889;
    cursor: pointer;
    &.city-active {
      color: #131415;
    }
  }

  .city-popup-content {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    overflow: hidden;
    z-index: 10000;
    box-shadow: 0px 8px 16px 0px rgba(19, 20, 21, 0.15);
    @include media(
      (
        $md: (
          width: 100vw,
        ),
      )
    );
  }
  .city-popup-pick {
    overflow: hidden;
    overflow-y: auto;
  }

  .isTabBar {
    padding-bottom: 186px !important;
  }
  .city-popup-pick .pick-item {
    font-size: 14px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 8px 16px;
    width: 100%;
    color: #131415;
    cursor: pointer;
    font-weight: 400;
    font-size: 22px;
    line-height: 36px;
    color: #131415;
    @include media(
      (
        $bg: (
          font-size: 18px,
          line-height: 28px,
        ),
        $md: (
          font-size: 16px,
          line-height: 26px,
        ),
      )
    );
  }
  .city-popup-pick .shop-pick-item {
    padding: 10px 15px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .distance,
    .shop-address {
      font-style: normal;
      font-weight: 400;
      font-size: 12px;
      line-height: 20px;
      color: #878889;
      margin-top: 4px;
      @include media(
        (
          $bg: (
            font-size: 12px,
            line-height: 20px,
          ),
        )
      );
    }
  }
  // .city-popup-pick .pick-active {
  //   color: #00b9ef !important;
  //   .shop-name {
  //     color: #00b9ef;
  //   }
  // }
}
</style>
